import { el } from 'redom';

import { stringToSVG } from 'utilities';

import HelptapEditor from '../../helpers';

import copyIconString from 'assets/images/copy-node-icon.svg?raw';

const copyIcon = stringToSVG(copyIconString);

class CopyNodeButton {

  constructor(menu, configuration) {

    this.menu = menu;

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;

    this.el = el('button.copy-node-button', {
      type: 'button',
      onclick: this.handleButtonClick.bind(this)
    }, [copyIcon.cloneNode(true), el('label', 'Copy')]);

  }

  handleButtonClick() {

    HelptapEditor.copyPaste.copyBlocks(this.editor, [this.activeNodePath]);

    this.menu.onClose();

  }

  update(configuration) {

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;

  }

}

export default CopyNodeButton;
